// useActorCapabilities.js — member capability surface

import { useMemo } from 'react';

const MEMBER_CAPABILITIES = Object.freeze({
  canOpen: true,
  canSelect: true,
  canEdit: true,
  canCreate: true,
  canDelete: true,
  canManageView: true,
  canInvite: true,
  canSettings: true,
  canTalk: true,
  canAsk: true,
});

/**
 * Returns explicit capabilities for the current actor.
 */
const useActorCapabilities = () => useMemo(() => ({
  ...MEMBER_CAPABILITIES,
}), []);

export default useActorCapabilities;
